import React from 'react';
import { BoxV2 as Box, Flex, SxProps } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export interface RadioButtonProps {
  label?: React.ReactNode;
  value?: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  disabled?: boolean;
  name?: string;
  sx?: SxProps;
  'data-testid'?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  checked,
  onChange,
  disabled,
  name,
  sx,
  'data-testid': testId,
}) => {
  const handleClick = () => {
    if (!disabled && onChange && value !== undefined) {
      onChange(value);
    }
  };

  return (
    <Flex
      role="radio"
      aria-checked={checked}
      aria-disabled={disabled}
      sx={{
        alignItems: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        gap: '8px',
        opacity: disabled ? 0.5 : 1,
        userSelect: 'none',
        position: 'relative',
        ...sx,
      }}
      onClick={handleClick}
      data-testid={testId}
    >
      {/* Hidden native input for form accessibility and testing */}
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none',
        }}
        readOnly
      />
      <Box
        sx={{
          width: '15px',
          height: '15px',
          borderRadius: '50%',
          border: '1.5px solid',
          borderColor: disabled ? '#CCCFD0' : '#808789',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          position: 'relative',
          flexShrink: 0,
        }}
      >
        {checked && (
          <Box
            sx={{
              color: '#0091B3',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pl: 2,
            }}
          >
            <FontAwesomeIcon icon={faCheck} />
          </Box>
        )}
      </Box>
      {label && (
        <Box
          sx={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#49535D',
            lineHeight: 'normal',
          }}
        >
          {label}
        </Box>
      )}
    </Flex>
  );
};

export default RadioButton;
